export interface TradingAccountActivityDto {
  ipAddress: string | null
  deviceKey: string | null
  count: number
  dateFrom: string
  dateTo: string
}

export enum TradingAccountActivityDtoKey {
  ipAddress = 'ipAddress',
  deviceKey = 'deviceKey',
  count = 'count',
  dateFrom = 'dateFrom',
  dateTo = 'dateTo',
}
